import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import {
	ChangeCategoryPositionContext,
	IChangeCategoryPositionContext,
} from '../../../../changeCategoryPositionState/changeCategoryPositionContext';
import classNames from 'classnames';
import style from './ResetBtn.module.scss';

const ResetBtn: React.FC = () => {
	const { resetSelectedControls, IDSelectedCustomer, selectedRestaurant } =
		useContext<IChangeCategoryPositionContext>(ChangeCategoryPositionContext);

	const resetBtnClasses = classNames(style.resetBtn, {
		[style.active]: IDSelectedCustomer || selectedRestaurant,
	});

	return (
		<Button
			className={resetBtnClasses}
			theme="secondary"
			onClick={resetSelectedControls}
			icon={
				<svg className={style.icon}>
					<use xlinkHref={`${breadcrumbs}#resetIcon`} />
				</svg>
			}
			data-test="ResetBtn">
			<Text translationNameSpace="listing" translationKey="resetButton" asFragment={true} />
		</Button>
	);
};

export default ResetBtn;
